import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnDestroy, Output} from '@angular/core';
import {AsyncPipe, NgIf} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {BehaviorSubject, distinctUntilChanged, map, Subscription} from 'rxjs';
import {EphemeralRealtimeService} from '../../core/services/ephemeral-realtime.service';

@Component({
  selector: 'app-typing-indicator', standalone: true,
  imports: [AsyncPipe, NgIf, TranslateModule], changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<ng-container *ngIf="names$ | async as names"><small *ngIf="names.length" class="block text-color-secondary" [class.mt-1]="!compact" role="status">{{
    translationKey(names.length) | translate:{names: names.slice(0, 3).join(', '), count: names.length}
  }}</small></ng-container>`,
})
export class TypingIndicatorComponent implements OnChanges, OnDestroy {
  @Input() channel: string | null = null;
  @Input() compact = false;
  @Output() activeChange = new EventEmitter<boolean>();
  names$ = new BehaviorSubject<string[]>([]);
  private release?: () => void;
  private activity?: Subscription;

  constructor(private readonly realtime: EphemeralRealtimeService) {}
  ngOnChanges(): void {
    this.activity?.unsubscribe();
    this.release?.();
    this.names$ = this.channel ? this.realtime.typingNames(this.channel) : new BehaviorSubject<string[]>([]);
    this.release = this.channel ? this.realtime.watchTyping(this.channel, !this.compact) : undefined;
    this.activity = this.names$.pipe(map(names => names.length > 0), distinctUntilChanged())
      .subscribe(active => this.activeChange.emit(active));
  }

  translationKey(count: number): string {
    if (this.compact) return 'realtime.typing_short';
    const key = this.channel?.startsWith('typing_comments:') ? 'realtime.comment_typing' : 'realtime.typing';
    return count > 1 ? key + '_many' : key;
  }

  ngOnDestroy(): void { this.activity?.unsubscribe(); this.release?.(); }
}
